import { render, staticRenderFns } from "./svgCafebazaar.vue?vue&type=template&id=793ba34c&scoped=true"
import script from "./svgCafebazaar.vue?vue&type=script&lang=js"
export * from "./svgCafebazaar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793ba34c",
  null
  
)

export default component.exports